<template>
	<div>
		<!-- v-if="this.fullyLoggedIn" :username="username"-->
		<topnav-layout />
		<!-- <button @click="openModalSession">Show Modal Session</button> -->
		<div id="layoutSidenav">
			<!-- Sidenav  v-if="this.fullyLoggedIn"  :username="username"-->
			<div id="layoutSidenav_nav">
				<sidenav-layout :sidenavStyle="sidenavStyle" :sidenavBg="sidenavBg" />
			</div>
			<div id="layoutSidenav_content">
				<main>
					<slot />
					<!-- Footer v-if="this.fullyLoggedIn"-->
				</main>
				<footer-layout :footerStyle="footerStyle" />
			</div>
		</div>
		<!-- v-if="this.fullyLoggedIn" -->
		<modal-session ref="componentModalSession" :modalTime="this.modalTime" />
		<modal-spinners ref="componentModalSpinners"/>


	</div>
</template>
<script>

import Topnav from '@/layouts/templates/Topnav.vue';
import Sidenav from '@/layouts/templates/Sidenav.vue';
import Footer from '@/layouts/templates/Footer.vue';
import { jwtDecode } from "jwt-decode";
import ModalSession from '@/components/templates/Modals/ModalSession.vue'
import ModalSpinners from '@/components/templates/Modals/ModalSpinners.vue';

import { globalScriptMixin } from '@/mixins/globalScriptMixin'
import { linkActivationMixin } from '@/mixins/linkActivationMixin'


	export default {
		name: 'main-layout',
		mixins: [globalScriptMixin, linkActivationMixin],
		components: {
			'topnav-layout':Topnav,
			'sidenav-layout': Sidenav,
			'modal-session': ModalSession,
			'footer-layout': Footer,
			'modal-spinners': ModalSpinners
		},
		data() {
			return {
				sidenavStyle: process.env.VUE_APP_SIDENAV_STYLE || 'sidenav shadow-right', 
				sidenavBg: process.env.VUE_APP_SIDENAV_BG || 'sidenav-light',
				footerStyle: 'footer-admin',
				fullyLoggedIn: this.$store.getters.loggedIn,
				username: this.$store.getters.username,
				modalSessionTimeout: null,
				modalTime: process.env.VUE_APP_SESSION_LOGOUT_TIMER || 300				
			}
		},
		created() {
			this.showModalSession()
		},

		updated() {
			// this.showModalSession()
		},
		methods: {
			
			async showModalSession() {
				// console.log ('showModalSession démarée')
				if (this.$store.getters.accessToken) {
					const actualDate = Math.floor(Date.now() / 1000);
					const expToken = jwtDecode(this.$store.getters.accessToken).exp;
					// this.modalTime à 300, 5 min avant on affiche le modal
					const timeDiff = expToken - actualDate - this.modalTime
					var timeout = timeDiff *1000
					// console.log ('timeout == ', timeout )
					if(timeout > 0)
						this.modalSessionTimeout = setTimeout(() => {	
							this.$refs.componentModalSession.modalToggle();
							// that.clearSessionTimeout()
						}, timeout);
					else {
						console.log ('autoDeconnexion == ', timeout )
						this.$nextTick(function () {
							this.$refs.componentModalSession.autoLogout();
							this.$refs.componentModalSession.modalToggle();
						});
					}
					

				}
				else {
					// si pas de token on affiche session expirée
					console.log ('Token déjà expiré | autoDeconnexion')
					this.$nextTick(function () {
						this.$nextTick(() => {
							this.$refs.componentModalSession.autoLogout()
							/*this.$store.dispatch('showToast', {
								type: 'error', message: "Vous avez été déconnecté après une longue période d'inactivité"
							});*/
						});
						// this.$refs.componentModalSession.modalToggle();
					});
				}

				/*this.$store.dispatch('showToast', {
					type: 'warning', message: this.$t('toast.created.message')
				})*/
			},
			
		}
	}
</script>
<style>


	/* 
		#ecaf52: orange mapral
		#b94646 : rouge mapral

	*/
	.bg-gradient-company, .footer-admin, .sidenav-footer, .login-company, .modal-header, .modal-footer{
		background-color: #ecaf52;
		background-image: linear-gradient(135deg, #ecaf52 0%, #b94646 100%);
		color: #fff;
	}
	.modal-body{
		background-color: #fff;
	}
	.page-header.page-header-company {
		color: #fff;
	}
	
	.page-header-title {
		color: #fff !important;
	}

	.sidenav-company {
		background-color: #fff;
		color: #000000;
	}
	.sidenav-company .sidenav-menu .sidenav-menu-heading {
		/*color: #ecaf52;*/
		color: #fff;
		background-color: #b94646;
	}
	.sidenav-company .sidenav-menu .nav-link {
		color: #ecaf52;
	}
	.sidenav-company .sidenav-menu .nav-link:hover {
		color: #ff0000;
	}
	.sidenav-company .sidenav-menu .nav-link.active, sidenav-company .sidenav-menu .nav-link.active .nav-link-icon {
		color: #ff0000;
	}
	
	.sidenav-company .sidenav-menu-nested {
		border-left-color: rgba(255, 255, 255, 0.15);
	}
	.sidenav-company .sidenav-footer {
		background-color: rgba(0, 0, 0, 0.25);
	}

	a{
		/*color :#ecaf52 !important;*/
	}
	.text-primary {
		color: #ecaf52 !important;
	}
	.btn-primary, .page-item.active .page-link {
		color: #fff;
		background-color: #ecaf52 !important;
		border-color: #b94646 !important;
	}
	.card-waves .card-body {
		background-image: url("~@/assets/img/backgrounds/bg_c.jpeg") !important;
		background-position: center !important;
	}
	.input-valeur {
		background-color: #b94646 !important;
		color: white !important;
		font-weight: bold;
	}
	.align-right {
		text-align: right;
	}
	.align-left {
		text-align: left;
	}
	.align-center {
		text-align: center;
	}
	/* panel body */
	.vcp__body {
		height: 100% !important;
	}
	.amount-letter{
		font-weight: bold;
		font-style: italic;
		color: #fff;
		background-color: #b94646;
	}
</style>